export var Team;
(function (Team) {
    Team["Oslo"] = "Motty Oslo";
    Team["Mortgage"] = "Mortgage Oslo";
    Team["Fredrikstad"] = "Motty Fredrikstad";
    Team["Polska"] = "Motty Polska";
})(Team || (Team = {}));
